const state = {

    rotaSalva: true,
    confirmarSalvarRota: false,
    novaRota: "",
    verificacaoRotaSalva: null

}

const mutations = {

    setNovaRota(state, payload){
        state.novaRota = payload
    },

    setConfirmarSalvarRota(state, payload){
        state.confirmarSalvarRota = payload
    },

    setRotaSalva(state, payload){
        state.rotaSalva = payload
    },

    setVerificacaoRotaSalva(state, payload){
        state.verificacaoRotaSalva = payload
    }  


}

const getters = {
    rotaSalva: state => state.rotaSalva,
    confirmarSalvarRota: state => state.confirmarSalvarRota,
    novaRota: state => state.novaRota,
    verificacaoRotaSalva: state => state.verificacaoRotaSalva
}

export default {
    state,
    mutations,
    getters
}